import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledDetailPackageInfo = styled(Box)`
  min-width: ${(props) => props.useInfoCreditsApi && '300px'};
  width: max-content;
  padding: 12px 16px;

  .danger-text {
    color: ${COLOR.red} !important;
  }

  .lock-icon {
    color: ${COLOR.red};
  }

  .package-info-container {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .package-info {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    .free-characters {
      .free-characters-note {
        margin-top: 2px;
        gap: 2px;
        color: rgba(28, 28, 30, 0.64);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        word-wrap: break-word;
      }
    }

    .cycle-characters,
    .old-characters,
    .custom-characters {
      display: flex;
      gap: 64px;
      align-items: center;
      justify-content: space-between;

      .old-characters-note {
        display: flex;
        align-items: center;
        gap: 2px;
        color: rgba(28, 28, 30, 0.64);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        word-wrap: break-word;
      }
      .icon-lock-cycle {
        font-size: 16px;
        color: ${COLOR.redPrimary};
        margin: 0 2px;
      }
    }

    .preserver-date {
      color: rgba(28, 28, 30, 0.64);
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      word-wrap: break-word;
    }

    .divider {
      margin-top: 4px;
      margin-bottom: 12px;
    }
  }

  .package-note {
    color: rgba(28, 28, 30, 0.64);
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
  }
`;
